import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import './DocumentsDemarches.css';

const DOCUMENT_IMAGES = [
  '/images/cue.png',
  '/images/cartedesanté.png',
  '/images/permis.png',
  '/images/certif.png',
  '/images/baco.png',
  '/images/certielectronique.png',
  '/images/apostile.png',
  '/images/Traductionassermentées.png',
  '/images/antécédents .png'
];
const DOCUMENT_COLORS = ['#ff6b6b', '#4ecdc4', '#45b7d1', '#f9ca24', '#6c5ce7', '#a29bfe', '#fd79a8', '#fdcb6e', '#e17055'];

const DocumentsDemarches = () => {
  const { t } = useTranslation();
  const cardTitles = t('documentsPage.cards', { returnObjects: true });
  const [visibleCards, setVisibleCards] = useState([]);
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            cardTitles.forEach((_, index) => {
              setTimeout(() => {
                setVisibleCards((prev) => [...prev, index]);
              }, index * 200);
            });
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1 }
    );
    const sectionEl = sectionRef.current;
    if (sectionEl) observer.observe(sectionEl);
    return () => {
      if (sectionEl) observer.unobserve(sectionEl);
    };
  }, [cardTitles.length]);

  return (
    <div className="documents-page">
      <section className="page-hero">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-3 text-center">
              <img src="/images/logo.jpeg" alt={t('common.altLogo')} className="hero-logo" />
            </div>
            <div className="col-lg-9 text-center">
              <h1 className="page-title">{t('documentsPage.hero.title')}</h1>
              <p className="page-subtitle">{t('documentsPage.hero.subtitle')}</p>
            </div>
          </div>
        </div>
      </section>

      <section ref={sectionRef} className="documents-section py-5">
        <div className="container">
          <div className="row g-4 documents-grid">
            {cardTitles.map((title, index) => (
              <div key={index} className="col-lg-4 col-md-6">
                <div
                  className={`document-card ${visibleCards.includes(index) ? 'card-visible' : ''}`}
                  style={{ '--card-index': index, '--card-color': DOCUMENT_COLORS[index] }}
                >
                  <div className="document-image-container">
                    <img src={DOCUMENT_IMAGES[index]} alt={title} className="document-image" />
                  </div>
                  <h3 className="document-title">{title}</h3>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="documents-footer-section py-5 bg-light">
        <div className="container">
          <div className="documents-footer-card">
            <p className="documents-footer-text">{t('documentsPage.footer')}</p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default DocumentsDemarches;
